import { Container, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export default function UseCaseInfraPage() {
  return (
    <Container maxWidth="md">
      <Wrapper>
        <img style={{ height: 400 }} src="/work-in-progress.svg" />
        <Typography variant="h6">Zone under construction</Typography>
      </Wrapper>
    </Container>
  );
}

const Wrapper = styled(Stack)`
  gap: ${(props) => props.theme.spacing(4)};
  align-items: center;
  justify-content: center;
  height: 100%;
`;
